import { render, staticRenderFns } from "./SystemActivityBase.vue?vue&type=template&id=64d7b1f9"
import script from "./SystemActivityBase.vue?vue&type=script&lang=js"
export * from "./SystemActivityBase.vue?vue&type=script&lang=js"
import style0 from "./SystemActivityBase.vue?vue&type=style&index=0&id=64d7b1f9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports